import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiTitle } from 'src/ui/mui-ui-kit';;
import { setBreadcrumbs } from 'src/ui';
import { ClientSidePagingManager } from 'src/api';
import { fetchMetrcReceipts, getMetrcReceipts } from 'src/metrc';
import { MetrcReceiptTable } from '../components';

class MetrcPage extends Component {
  state = {
    loading: true,
    metrcReceipts: [],
  };

  constructor(props) {
    super(props);

    this.pagedMetrcReceipts = new ClientSidePagingManager(
      this.props.fetchMetrcReceipts, // eslint-disable-line react/destructuring-assignment
      () => this.props.metrcReceipts.metrcReceipts, // eslint-disable-line react/destructuring-assignment
      metrcReceipts => {
        this.setState({ metrcReceipts });
      }
    );
  }

  async componentDidMount() {
    const { setBreadcrumbs } = this.props;

    setBreadcrumbs([{ label: 'Metrc', href: '/metrc' }]);

    await this.pagedMetrcReceipts.fetch({
      customer: 1,
    });

    this.setState({ loading: false });
  }

  render() {
    const { loading, metrcReceipts } = this.state;

    return (
      <div className="metrc-page">
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          Metrc Receipts
        </MuiTitle>
        <MetrcReceiptTable
          loading={loading}
          paging={this.pagedMetrcReceipts}
          metrcReceipts={metrcReceipts || []}
        />
      </div>
    );
  }
}

MetrcPage.propTypes = {
  metrcReceipts: propTypes.object.isRequired,
  fetchMetrcReceipts: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    metrcReceipts: getMetrcReceipts(state),
  };
}

const connectedMetrcPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchMetrcReceipts,
})(MetrcPage);

export { connectedMetrcPage as MetrcPage };
